var _rect, _rect2, _path, _path2, _path3, _circle, _path4, _path5, _circle2, _path6, _circle3, _path7, _circle4, _path8, _path9, _circle5, _path10, _circle6, _path11, _circle7, _path12, _circle8, _path13, _circle9, _path14, _circle10, _path15, _path16, _circle11, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBetViewBDim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 54 49",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 42.667,
    x: 2.666,
    y: 3.333,
    fill: "url(#______src_modules_setting_svg_IcoBetViewBDim_svg__a)",
    fillOpacity: 0.3,
    rx: 2.667
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41.667,
    x: 3.166,
    y: 3.833,
    stroke: "url(#______src_modules_setting_svg_IcoBetViewBDim_svg__b)",
    strokeOpacity: 0.8,
    rx: 2.167
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.2,
    stroke: "#6B6B6B",
    strokeWidth: 0.667,
    d: "M5.665 6.333h7V14h-7zm7 0h7V14h-7zm7 0h14V14h-14zm14 0h7V14h-7zm7 0h7V14h-7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.2,
    stroke: "#6B6B6B",
    strokeWidth: 0.667,
    d: "M5.665 13.999h14v10.333h-14zm14 0h14v10.333h-14zm14 0h14v10.333h-14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M5.61 24.944h6.111v6.111H5.61z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M5.61 30.944h6.111v6.111H5.61z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M5.61 36.944h6.111v6.111H5.61zm6-12h6.111v6.111H11.61z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M11.61 30.944h6.111v6.111H11.61z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.666,
    cy: 34,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M11.61 36.944h6.111v6.111H11.61zm6-12h6.111v6.111H17.61z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M17.61 30.944h6.111v6.111H17.61z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M17.61 36.944h6.111v6.111H17.61zm6-12h6.111v6.111H23.61z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M23.61 30.944h6.111v6.111H23.61z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.666,
    cy: 34,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M23.61 36.944h6.111v6.111H23.61z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.666,
    cy: 40,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M29.61 24.944h6.111v6.111H29.61z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M29.61 30.944h6.111v6.111H29.61z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.666,
    cy: 34,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M29.61 36.944h6.111v6.111H29.61zm6-12h6.111v6.111H35.61z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M35.61 30.944h6.111v6.111H35.61z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M35.61 36.944h6.111v6.111H35.61zm6-12h6.111v6.111H41.61z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.666,
    cy: 28,
    r: 1.944,
    stroke: "#494949",
    strokeWidth: 0.556
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M41.61 30.944h6.111v6.111H41.61z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    stroke: "#494949",
    strokeWidth: 0.556,
    d: "M41.61 36.944h6.111v6.111H41.61z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_setting_svg_IcoBetViewBDim_svg__a",
    x1: 26.666,
    x2: 26.666,
    y1: 3.333,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_setting_svg_IcoBetViewBDim_svg__b",
    x1: 50.666,
    x2: 23.54,
    y1: 47.828,
    y2: -6.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBetViewBDim);
export default __webpack_public_path__ + "static/media/IcoBetViewBDim.f3aba21f8e78c035855ce9da0b1785e1.svg";
export { ForwardRef as ReactComponent };